export default __webpack_public_path__ + "static/media/img_02.09a2566c.jpg";